import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

export const loading = (theme: Theme, padding: number): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(padding, '0'),
  })
